module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-gray-dark-cf8ca90fc4ad9b2d587cd2ca692350e4.png";